import { render, staticRenderFns } from "./PlantingCategoryList.vue?vue&type=template&id=ef130598&scoped=true&"
import script from "./PlantingCategoryList.vue?vue&type=script&lang=js&"
export * from "./PlantingCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./PlantingCategoryList.vue?vue&type=style&index=0&id=ef130598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef130598",
  null
  
)

export default component.exports